import subDays from "date-fns/subDays";
import startOfDay from "date-fns/startOfDay";

// returns a date n days ago at start of day
const getDaysAgo = (days) => startOfDay(subDays(new Date(), days));

export default getDaysAgo;
